<template>
    <client-page class="app--main">
        <template v-if="!accessToken">
            <lecture-auth />
        </template>
        <template v-else>
            <lecture-view />
        </template>
    </client-page>
</template>

<script>
import { mapMutations, mapState } from "vuex";

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import LectureAuth from "@/components/client/lectures/auth/lecture-auth.vue";
import LectureView from "@/components/client/lectures/view/lecture-view.vue";

export default {
    components: {
        ClientPage,
        LectureAuth,
        LectureView,
    },
    props: {
        _lecture: { type: String, default: null },
    },
    computed: {
        ...mapState(["accessToken"]),
    },
    methods: {
        ...mapMutations("lecture", ["setLectureIndex"]),

        sync() {
            const { _lecture } = this;
            this.setLectureIndex({ _lecture });
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        _lecture() {
            this.sync();
        },
    },
};
</script>
